<template>
  <v-container fluid class="customer-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn 
                color="success" 
                class="button-shadow mr-3"
                @click="isFindCustomer=true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_customers.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="customers-table"
              show-select
              single-select
              item-key="_id"
              sort-by="lastOrderDate"
              :footer-props="footer"
              :headers="headers"
              :items="data_customers"

              :items-per-page="itemPerPage">
              <template v-slot:item.customerimage="{ item }">
                  <img v-if="item.customerimage" v-bind:src="item.customerimage" alt="" width="80">
              </template>
              <template v-slot:item.customername="{ item }">
                <a class="primaryConst--text">{{ item.customername }}</a>
                <p>{{ item.customertype }}</p>
              </template>
              <template v-slot:item.customeraddress="{ item }">
                <a class="primaryConst--text">{{ item.customeraddress }}</a>
                <p class="two-line">{{ item.customerphone  }}</p>
                <p class="two-line">{{ item.customermobile  }}</p>
              </template>
              <template v-slot:item.townshipid="{ item }">
                <p class="two-line">{{ item.regionid!=undefined && regions.find(region=>region._id == item.regionid)!=null ? regions.find(region=>region._id == item.regionid)['regionname'] : ''   }}</p>
                <p class="two-line">{{ item.townshipid!=undefined && townships.find(township=>township._id == item.townshipid)!=null ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}</p>
                <a class="primaryConst--text" target="_blank" v-bind:href="'http://maps.google.com/maps?q=' + item.geolocation.replace(' ', '')">Map</a>
              </template>
              <template v-slot:item.customerstatus="{ item }">
                <v-chip
                  :color="item.customerstatus=='Active' ? 'successConst white--text' : item.claimstatus=='New' ? 'primaryConst white--text' : item.claimstatus=='Inactive' ? 'greyTint white--text' : 'primaryConst white--text'"
                  small>
                  {{ item.customerstatus }}
                </v-chip>
              </template>
              <template v-slot:item.lastOrderDate="{ item }">
                <p v-if="item.lastOrderDate" class="two-line"><span style="font-size: x-small;">Last:</span> {{ new Date(item.lastOrderDate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                <p class="two-line"><span style="font-size: x-small;">Count:</span> {{ item.orders.length }}</p>
              </template>
              <template v-slot:item.createdAt="{ item }">
                <p class="two-line">{{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}</p>
                <p class="two-line">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </p>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="viewProfile(item.profile)">
                  <v-icon>mdi-text-box-search</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isFindCustomer"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Customers</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    :items="users.filter(x=>x.userstatus=='Active').map(x => {
                              return {text: x.username, value: x._id};
                            })"
                    v-model="find_query.userid"
                    label="Sales Rep"
                    required
                  ></v-select>
                  <v-select
                    :items="regions.filter(x=>x.regionstatus=='Active').map(x => {
                              return {text: x.regionname, value: x._id};
                            })"
                    v-model="find_query.regionid"
                    label="Region"
                    required
                  ></v-select>
                  <v-select
                    :items="townships.filter(x=>x.townshipstatus=='Active' && x.regionid==find_query.regionid).map(x => {
                              return {text: x.townshipname, value: x._id};
                            })"
                    v-model="find_query.townshipid"
                    label="Township"
                    required
                  ></v-select>
                  <v-select
                          class="mb-4"
                          :items="[30,60,90,120,150,180]"
                          :value="90"
                          v-model="find_query.criteria"
                          placeholder="Criteria"
                          persistent-hint
                          single-line hint="Please choose the active criteria">
                        </v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindCustomer = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetSalesOrders"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findCustomers"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
      <div>
      <v-dialog
      v-model="showViewProfile"
      max-width="1000px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">View Profile</span>
        </v-card-title>
          <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                        </th>
                        <th class="text-left">
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><b>Purchase amount</b></td>
                        <td>{{ profile['purchaseAmount'] }}</td>
                      </tr>
                      <tr>
                        <td><b>Ordering frequency</b></td>
                        <td>{{ profile['orderingFrequency'] }}</td>
                      </tr>
                      <tr>
                        <td><b>Our items sold by customer</b></td>
                        <td>{{ getItems(profile['ownItems']) }}</td>
                      </tr>
                      <tr>
                        <td><b>Our brands sold by customer</b></td>
                        <td>{{ getBrands(profile['ownBrands']) }}</td>
                      </tr>
                      <tr>
                        <td><b>Other brands sold by customer</b></td>
                        <td>{{ getBrands(profile['otherBrands']) }}</td>
                      </tr>
                      <tr>
                        <td><b>Product groups sold by customer</b></td>
                        <td>{{ getGroups(profile['groups']) }}</td>
                      </tr>
                      <tr>
                        <td><b>Product categories sold by customer</b></td>
                        <td>{{ getCategories(profile['categories']) }}</td>
                      </tr>
                      <tr>
                        <td><b>Our POSM at this location</b></td>
                        <td>{{ profile['haveOwnPosm'].join(", ") }}</td>
                      </tr>
                      <tr>
                        <td><b>Other POSM at this location</b></td>
                        <td>{{ profile['haveOtherPosm'].join(", ") }}</td>
                      </tr>
                      <tr>
                        <td><b>POSM requested by customer</b></td>
                        <td>{{ profile['requestedPosm'].join(", ") }}</td>
                      </tr>
                      <tr>
                        <td><b>Preferred promotion schemes</b></td>
                        <td>{{ profile['promotionSchemes'].join(", ") }}</td>
                      </tr>
                      <tr>
                        <td><b>Notes</b></td>
                        <td>{{ profile['profilenote'] }}</td>
                      </tr>
                      <tr></tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
            </v-col>
            </v-row>
            
          </v-container>
          
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="showViewProfile = false"
            >
              Close
            </v-btn>
          </v-card-actions>
      </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CustomerList',
  data() {
    return {
      headers: [
        { text: 'Image', value: 'customerimage', sortable: false, width: "5%" },
        { text: 'Name', value: 'customername', width: "10%"},
        { text: 'Address', value: 'customeraddress', width: "15%"},
        { text: 'Location', value: 'townshipid' },
        
        { text: 'Orders', value: 'lastOrderDate' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Status', value: 'customerstatus', width: "7%"},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,

      
      profile: {},
      showViewProfile: false,

      data_customers: [],
      isDeleteCustomer: false,
      delete_customer: {},
      isFindCustomer: false,
      find_query: {},
      menu_startdate: null,
      menu_enddate: null,   
    }
  },
  computed: {
    ...mapState('Customer', ['actives', 'isReceiving', 'isDeleting', 'idToDelete', 'customersMessage', 'isUpdating']),
    ...mapState('Brand', ['brands']),
    ...mapState('Item', ['items']),
    ...mapState('ItemCategory', ['itemcategories']),
    ...mapState('ItemGroup', ['itemgroups']),
    ...mapState('Location', ['locations']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  async created () {
    if(this.actives.length==0) await this.getCustomersActiveRequest();
    this.data_customers = this.actives;
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.itemcategories.length==0) await this.getItemCategoriesRequest();
    if(this.itemgroups.length==0) await this.getItemGroupsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
  methods: {
    ...mapActions('Brand', ["getBrandsRequest"]),
    ...mapActions('Customer', ["getCustomersActiveRequest", "findCustomersActiveQueryRequest", "deleteCustomerRequest"]),
    ...mapActions("CustomerProfile", ["getCustomerProfiles"]),
    
    ...mapActions('Item', ["getItemsRequest"]),
    ...mapActions('ItemCategory', ["getItemCategoriesRequest"]),
    ...mapActions('ItemGroup', ["getItemGroupsRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    editItem(item) {
      this.$router.push({ name: 'CustomerEdit', params: item })
    },
    async findCustomers(){
      this.isFindCustomer = false;
      if(this.find_query=={}){
        await this.getCustomersActiveRequest();
        this.data_customers = this.customers;
      }
      else{
        let result = await this.findCustomersActiveQueryRequest(this.find_query);
        this.data_customers = result;
      }
    },
    getJson(){
      let json = this.data_customers.map(customer=>{return {
        customername: customer.customername, 
        type: customer.customertype,
        address: customer.customeraddress,
        phone: customer.customerphone,
        mobile: customer.customermobile,
        region: customer.regionid!=undefined && this.regions.length>0 ? this.regions.find(region=>region._id == customer.regionid)['regionname'] : '',
        township: customer.townshipid!=undefined && this.townships.length>0 ? this.townships.find(town=>town._id == customer.townshipid)['townshipname'] : '',
        salesrep: customer.userid!=undefined && this.users.length>0 ? this.users.find(user=>user._id == customer.userid)['username'] : '',
        createddate: customer.createdAt!=undefined ? new Date(customer.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        lastorder: customer.lastOrderDate!=undefined ? new Date(customer.lastOrderDate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        ordercount: customer.orders.length>0 ? customer.orders.length : '',
        map: 'http://maps.google.com/maps?q=' + customer.geolocation.replace(' ', ''),
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'customers-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    getBrands(list){
      let results = list.map(obj=> this.brands.find(brand=>brand._id==obj).brandname);
      return results.join(", ");
    },
    getItems(lists){
      let results = lists.map(obj=> this.items.find(item=>item._id==obj).itemname);
      return results.join(", ");
    },
    getCategories(lists){
      let results = lists.map(obj=> this.itemcategories.find(category=>category._id==obj)!=null ? this.itemcategories.find(category=>category._id==obj).itemcategoryname : '');
      return results.join(", ");
    },
    getGroups(lists){
      let results = lists.map(obj=> this.itemgroups.find(group=>group._id==obj)!=null ? this.itemgroups.find(group=>group._id==obj).itemgroupname : '');
      return results.join(", ");
    },
    async resetSalesOrders(){
      this.find_query = {};
    },
    viewItem(item) {
      this.$router.push({ name: 'CustomerView', params: item })
    },
    viewProfile(item) {
      this.profile = item;
      this.showViewProfile = true;
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
